var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sectionWrap"},[_c('p',{staticClass:"sectionTitle"},[_c('b'),_c('span',[_vm._v(_vm._s(_vm.list.title))]),_c('b')]),_c('p',{staticClass:"sectionInfo"},[_vm._v(" "+_vm._s(_vm.list.description)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }